export default {
  id: 'NewPaymentModal',
  code: 'CN',
  text: {
    'Hours To Be Refunded': '退掉多少小时',
    'Refund Lesson Until...': '退款后课期为',
    'Number Of Lesson To Refund': '退掉多少课次',
    'Refund Method': '退款方式',

    'Online Payment': '在线支付',
    'Transaction Record': '记账',
    'WeChat Pay': '微信支付',
    'Alipay': '支付宝',
    'Proceed to payment': '下一步',

    'Remarks': '备注',
    'Email': '邮箱',
    'Paper Receipt Number': '纸质收据号',
    'Send Receipt To Parents': '电子收据会通过邮件发给家长',

    'Top-up Amount': '充值金额',
    'Top-up Date': '充值日期',
    'Payment Methods': '付款方式',

    'Charge Amount': '收款金额',
    'Class': '班级',
    'Charge Date': '收款日期',

    'Purchase Lesson Until...': '购买课期至',
    'Refund Lesson Until...': '退款课期至',

    'Used Lessons/Purchased Lessons': '消耗课次/购买课次',
    'Used Hours/Purchased Hours': '消耗课时/购买课时',

    'Number of lessons': '购买课次',
    'Number of hours': '购买课时',

    'Refund Amount': '退款金额',
    'Refund Date': '退款日期',
    'Refund Lessons': '退款课次',
    'Refund Hours': '退款课时',

    'Term Rate': '课期总价',
    'Hour Rate': '课次单价',
    'Lesson Rate': '课时单价',

    'Discount Price': '折扣金额',
    'Total Price': '应付金额',
    'Net Price': '实付金额',

    'Refund Class Fee': '班级退款',
    'Refund Credits': '钱包退款',
    'Refund Methods': '退款方式',

    'Scan Payment QR Code': '扫描付款QR码',
    'Please do not close this window during scanning': '扫描时请不要关闭当前窗口',
    'Payment Successful': '付款成功！',
    'Confirm': '确定',
    'Setup': '未设置',

    'This school has not integrate weChat Pay and AliPay, please contact our product specialist': '此学校未开通微信支付和支付宝支付，请联系我们的产品专家',

    'Payment Request Timeout': '付款请求超时',
    'Processing...': '处理中...',

  }
}



// WEBPACK FOOTER //
// ./src/template/Modals/NewPayment/locale.js